const removeSpace = (string) => string.split(" ").join("_");

// dob is no longer part of the email since it is also the default password,
// a random suffix is used instead. Suffixes are cached per name + dob so the
// email stays the same across re-renders of the registration forms.
const suffixes = new Map();

const randomSuffix = () => Math.random().toString(36).slice(2, 8);

const generateEmail = (user) => {
  if (typeof user !== "object") return "-";

  const { fullName, dob = "" } = user,
    { lname = "", fname = "" } = fullName || {};

  if (!fname && !lname) return "-";

  const key = `${lname}|${fname}|${dob || ""}`.toLowerCase();
  if (!suffixes.has(key)) suffixes.set(key, randomSuffix());

  return `${removeSpace(lname)}.${removeSpace(fname)}.${suffixes.get(
    key
  )}@smartcare.com.ph`;
};

export default generateEmail;
